<template>
  <ZubieDialog
    card-class="mapped-list-dialog__card"
    content-class="mapped-list-dialog__content q-px-none"
    :inner-dialog-height-offset="58"
    :maximized="true"
    no-focus
    no-refocus
    ok-only
    seamless
    title="Vehicles &amp; Assets"
    title-color="secondary"
    title-dense
    title-style="padding: 2px 0; font-size: 20px; letter-spacing: 0.005em; font-weight: 400"
    title-text-color="black"
    transition-hide="slide-down"
    transition-show="slide-up"
    :visible="listDialogOpen"
    @before-show="onBeforeShow"
    @hide="onHide"
    @show="onShow"
  >
    <MappedAssetsList @click.stop @item-select="closeListDialog" />
  </ZubieDialog>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import MappedAssetsList from 'components/map/MappedAssetsList.vue';
import { useOutsideClick } from 'src/composables/outside-click';
import { setTimeoutPromise } from 'src/services/setTimeout';

const store = useStore();

const listDialogOpen = computed<boolean>(() => store.state.map.listDialogOpen);

function closeListDialog() {
  return store.dispatch('map/closeListDialog');
}

let mappedListDialogCard: HTMLElement | null = null;
let searchBar: HTMLElement | null = null;

function modalClickStopper(event: Event) {
  event.stopPropagation();
}

const { addOutsideClickListener, removeOutsideClickListener } = useOutsideClick(
  'mappedAssetsListDialog',
  () => removeListDialog(),
  false
);

async function removeListDialog() {
  if (listDialogOpen.value) {
    await closeListDialog();
  }
  document.body.classList.remove('map-list-dialog--open');
  mappedListDialogCard?.removeEventListener('click', modalClickStopper);
  searchBar?.removeEventListener('click', modalClickStopper);
  removeOutsideClickListener();
  mappedListDialogCard = null;
  searchBar = null;
}

function onHide() {
  void removeListDialog();
}

async function onBeforeShow() {
  document.body.classList.add('map-list-dialog--open');
}

async function onShow() {
  await setTimeoutPromise(100);

  const dialog = document.querySelector<HTMLElement>('.q-dialog');
  dialog?.classList.add('map-list-dialog');

  const innerDialog = document.querySelector<HTMLElement>('.q-dialog__inner');
  innerDialog?.addEventListener('click', () => {
    document.body.dispatchEvent(new Event('click'));
  });

  mappedListDialogCard = document.querySelector<HTMLElement>('.mapped-list-dialog__card');
  searchBar = document.querySelector<HTMLElement>('.universal-search');
  mappedListDialogCard?.addEventListener('click', modalClickStopper);
  searchBar?.addEventListener('click', modalClickStopper);
  addOutsideClickListener();
}

onBeforeUnmount(() => {
  void removeListDialog();
});
</script>

<style lang="scss">
body.platform-ios .map-list-dialog .q-dialog__inner > div {
  max-height: 100% !important;
}

.map-list-dialog--open {
  .q-page {
    opacity: 0.3;

    @media (min-width: $breakpoint-sm) {
      opacity: 1;
    }
  }

  .map-list-dialog {
    .q-dialog__inner {
      top: calc(var(--safe-area-top) + 58px) !important;
      pointer-events: all !important;
      transition: all 0.3s ease-out;

      > div {
        max-height: 100% !important;
      }
    }

    .dialog--body {
      padding: 8px 0 0;
    }

    .dialog--footer .q-btn {
      padding: 8px 0;
    }

    .dialog--footer .q-btn__wrapper {
      min-height: 0;
    }
  }
}
</style>
